// clipboard.js v2.0.4 is a webpack UMD bundle: under esbuild the
// `module.exports = factory()` branch wins, so it never runs its
// `root["ClipboardJS"] = factory()` browser-global branch. Legacy inline view
// scripts use the bare `ClipboardJS` global (e.g. `new ClipboardJS('#copy_link')`
// in events/personel, events/grids, events/guests), so expose it on window here.
import ClipboardJS from "../vendor/clipboard.js"

window.ClipboardJS = ClipboardJS

export default ClipboardJS
